
import { IntroSequencing } from "./util/intro_sequencing.js";
import * as ModelViewer from '@google/model-viewer/dist/model-viewer.js';
import LaptopUrl from "url:./static/Laptop.glb";
import TrainUrl from "url:./static/TrainAssemCOLORGLB.glb";
import EtchAUrl from "url:./static/EtchAGLB.glb";
import HeadbandUrl from "url:./static/LUX.glb";
import WorkspaceUrl from "url:./static/HumanCAD_Model.glb";
import Hammer from 'hammerjs';
import { Toast } from "./util/toast.js";
import { isMobile } from "./util/utils.js";

console.log(ModelViewer);

document.getElementById("laptop-model").src = LaptopUrl;
document.getElementById("train-model").src = TrainUrl;
document.getElementById("etchA-model").src = EtchAUrl;
document.getElementById("headband-model").src = HeadbandUrl;
document.getElementById("workspace-model").src = WorkspaceUrl;

document.getElementById('left-arrow').addEventListener('click', () => {
    IntroSequencing.stopTypingCursor();
    updateSlideIndex(-1);
    window.scrollTo(0, 0); // Scroll to the top of the page
    Toast.dismissEarly();
});
document.getElementById('right-arrow').addEventListener('click', () => {
    IntroSequencing.stopTypingCursor();
    updateSlideIndex(1);
    window.scrollTo(0, 0); // Scroll to the top of the page
    Toast.dismissEarly();
});
document.getElementById('down-arrow').addEventListener('click', () => scrollPage(550));

var swipeArea = document.body; // or another element if you prefer

var hammerInstance = new Hammer(swipeArea);

document.addEventListener('DOMContentLoaded', function () {
    seedSlideNotchIndicators();
    setSlideIndex(0);

    // Initialize Hammer.js and register swipe events
    var swipeArea = document.body; // Adjust this as needed
    var hammerInstance = new Hammer(swipeArea);
    hammerInstance.on("swipeleft", function () {
        updateSlideIndex(1); // Next slide on swipe left
        window.scrollTo(0, 0);
        IntroSequencing.stopTypingCursor();
    });
    hammerInstance.on("swiperight", function () {
        updateSlideIndex(-1); // Previous slide on swipe right
        window.scrollTo(0, 0);
        IntroSequencing.stopTypingCursor();
    });

    checkForOverflowContent();
    initCursorTrail();
});




// seed the indicator
function seedSlideNotchIndicators() {
    // Select the container where the slide notches will be appended
    var indicatorContainer = document.querySelector('.presentation-slide-indicator');
    // remove any existing children
    while (indicatorContainer.firstChild) {
        indicatorContainer.removeChild(indicatorContainer.firstChild);
    }

    // Select all the slide elements
    var slides = document.querySelectorAll('.slide');

    // Loop through each slide and append a notch for each
    slides.forEach(function () {
        var notch = document.createElement('div');
        notch.className = 'slide-notch';
        indicatorContainer.appendChild(notch);
    });
}

function getMaxSlideCount() {
    return document.querySelectorAll('.slide').length;
}

function setSlideIndex(index) {
    // Select all slide elements
    var slides = document.querySelectorAll('.slide');

    // Loop through each slide
    slides.forEach(function (slide, slideIndex) {
        if (slideIndex === index) {
            // Show the slide if its index matches the provided index
            slide.style.display = 'block';
        } else {
            // Hide the other slides
            slide.style.display = 'none';
        }
    });

    // update the notch indicators
    var notches = document.querySelectorAll('.presentation-slide-indicator .slide-notch');
    notches.forEach(function (notch, notchIndex) {
        if (notchIndex === index) {
            notch.classList.add('active-notch');
        } else if (notchIndex < index) {
            notch.classList.add('prev-notch');
        } else {
            notch.classList.remove('prev-notch');
            notch.classList.remove('active-notch');
        }
    });

    // update the arrows
    var leftArrow = document.getElementById('left-arrow');
    if (index === 0) {
        leftArrow.style.opacity = '0';
    } else {
        leftArrow.style.opacity = '1';
    }

    var rightArrow = document.getElementById('right-arrow');
    if (index + 1 >= getMaxSlideCount()) {
        rightArrow.style.opacity = '0';
    } else {
        rightArrow.style.opacity = '1';
    }
}

/**
 * 
 * @returns index of the active slide or null if no slide is active
 */
function getActiveSlideIndex() {
    // Select all slide elements
    var slides = document.querySelectorAll('.slide');

    // Iterate through the slides to find the one that is visible
    for (var i = 0; i < slides.length; i++) {
        if (slides[i].style.display === 'block' || window.getComputedStyle(slides[i]).display === 'block') {
            // Return the index of the active slide
            return i;
        }
    }
    return null;
}

/**
 * updates the slide index by appling an integer delta
 * @param {number} delta 
 */
function updateSlideIndex(delta) {
    const currentSlideIndex = getActiveSlideIndex();
    if (currentSlideIndex == null) {
        throw Error("invalid state: unable to disambiguate the current slide index")
    }
    if (currentSlideIndex + delta < 0) {
        // negative slide index, stay at the first index
        return;
    }

    if (currentSlideIndex + delta >= getMaxSlideCount()) {
        // out of bounds
        return;
    }

    setSlideIndex(currentSlideIndex + delta)
    if (delta > 0) {
        // moving towards the right
        document.getElementById("right-arrow").style.animation = "linear 0.6s arrow-fade-pulse";
        setTimeout(function () {
            document.getElementById("right-arrow").style.animation = "none";
        }, 600);
    } else {
        // moving towards the left
        document.getElementById("left-arrow").style.animation = "linear 0.6s arrow-fade-pulse";
        setTimeout(function () {
            document.getElementById("left-arrow").style.animation = "none";
        }, 600);
    }
    checkForOverflowContent();
}


function registerModelViewerListeners() {
    document.getElementById("laptop-model").addEventListener("load", function () {
        IntroSequencing.markModelsAsLoaded();
    })
}

function checkForOverflowContent() {
    const downArrow = document.getElementById('down-arrow');
    if (!downArrow) return;

    const activeIndex = getActiveSlideIndex();
    if (activeIndex == null) {
        downArrow.style.display = "none";
        return;
    }

    const slides = document.querySelectorAll('.slide');
    const activeSlide = slides[activeIndex];
    if (!activeSlide) {
        downArrow.style.display = "none";
        return;
    }

    const rect = activeSlide.getBoundingClientRect();
    const available = window.innerHeight - rect.top - 16; // small buffer
    const needsScroll = activeSlide.scrollHeight > available + 8;
    downArrow.style.display = needsScroll ? "flex" : "none";
}

// Function to perform smooth scrolling
function scrollPage(amount) {
    console.log(amount)
    window.scrollBy({
        top: amount,
        left: 0,
        behavior: 'smooth'
    });
}

function initCursorTrail() {
    if (isMobile()) return;
    const segments = [];
    let lastPoint = null;
    let fadeTimer = null;
    const idleDelay = 1000;

    function createSegment(x1, y1, x2, y2) {
        const dx = x2 - x1;
        const dy = y2 - y1;
        const dist = Math.min(Math.hypot(dx, dy), 28);
        if (dist < 2) return;

        const angle = Math.atan2(dy, dx) * 180 / Math.PI;
        const midX = x1 + dx / 2;
        const midY = y1 + dy / 2;

        const seg = document.createElement('span');
        seg.className = 'ink-seg';
        const thickness = 1.6 + Math.random() * 0.8;
        const opacity = 0.18 + Math.random() * 0.12;
        seg.style.width = `${dist + 6}px`;
        seg.style.height = `${thickness}px`;
        seg.style.left = `${midX}px`;
        seg.style.top = `${midY}px`;
        seg.style.opacity = `${opacity}`;
        seg.style.transform = `translate(-50%, -50%) rotate(${angle}deg) scaleX(1)`;
        seg.style.background = `linear-gradient(90deg,
            rgba(15,23,42,${opacity * 1.7}) 0%,
            rgba(59,98,132,${opacity * 1.35}) 50%,
            rgba(12,74,110,${opacity * 0.5}) 100%)`;

        document.body.appendChild(seg);
        segments.push(seg);
    }

    window.addEventListener('mousemove', (e) => {
        if (!lastPoint) {
            lastPoint = { x: e.clientX, y: e.clientY };
            return;
        }
        createSegment(lastPoint.x, lastPoint.y, e.clientX, e.clientY);
        lastPoint = { x: e.clientX, y: e.clientY };
        scheduleFade(false);
    });

    window.addEventListener('mouseleave', () => {
        lastPoint = null;
        scheduleFade(true);
    });

    function scheduleFade(force = false) {
        if (fadeTimer) clearTimeout(fadeTimer);
        fadeTimer = setTimeout(() => {
            segments.forEach((seg) => {
                seg.style.opacity = '0';
                const current = seg.style.transform || '';
                const scaled = current.includes('scaleX(')
                    ? current.replace(/scaleX\([^)]*\)/, 'scaleX(0.5)')
                    : `${current} scaleX(0.5)`;
                seg.style.transform = scaled;
                setTimeout(() => {
                    const idx = segments.indexOf(seg);
                    if (idx > -1) segments.splice(idx, 1);
                    seg.parentNode?.removeChild(seg);
                }, 2200);
            });
        }, force ? 0 : idleDelay);
    }
}

function checkScroll() {
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
        // Hide the element when at the bottom
        document.getElementById('down-arrow').style.display = 'none';
    }
}

// Event listener for the scroll event
window.addEventListener('scroll', checkScroll);

var keys = {};

window.addEventListener("keydown",
    function (e) {
        keys[e.code] = true;
        switch (e.code) {
            case "ArrowUp": case "ArrowDown": case "ArrowLeft": case "ArrowRight":
            case "Space": e.preventDefault(); break;
            default: break; // do not block other keys
        }
    },
    false);

document.addEventListener('keydown', function (event) {
    if (event.keyCode === 37) {
        IntroSequencing.stopTypingCursor();
        updateSlideIndex(-1);
        window.scrollTo(0, 0);
        Toast.dismissEarly();

    } else if (event.keyCode === 39) {
        IntroSequencing.stopTypingCursor();
        updateSlideIndex(1);
        window.scrollTo(0, 0);
        Toast.dismissEarly();
    } else if (event.keyCode === 40) { // Arrow Down
        IntroSequencing.stopTypingCursor();
        scrollPage(550); // Scroll down by 275
        Toast.dismissEarly();

    } else if (event.keyCode === 38) { // Arrow Up
        IntroSequencing.stopTypingCursor();
        scrollPage(-550); // Scroll up by 275px
        Toast.dismissEarly();
    }
});

document.addEventListener('DOMContentLoaded', function () {
    seedSlideNotchIndicators();
    setSlideIndex(0);

    // Check for overflow content and show toast if needed
    checkForOverflowContent();
    // Register arrow key scroll listeners
});

window.addEventListener('resize', checkForOverflowContent);

registerModelViewerListeners();
IntroSequencing.begin();
